import React from "react";
import PageLayout from "../components/PageLayout";
import PageHero from "../components/PageHero";
import Services from "../components/Services";
import Pricing from "../components/Pricing";
import Process from "../components/Process";
import ArtistSpotlight from "../components/ArtistSpotlight";
import InteractiveExperiences from "../components/InteractiveExperiences";

const ServicesPage = () => (
    <PageLayout title="Services & Pricing · IndoBlitz" testId="services-page">
        <PageHero
            eyebrow="Services"
            title="What we"
            accent="deliver."
            intro="Hire us to build, train with us to grow, or partner to deliver. Transparent pricing in your region's currency - no opaque quotes, no urban-IT markup."
            testId="services-hero"
        />
        <Services />
        <Pricing />
        <Process />
        <ArtistSpotlight />
        <InteractiveExperiences />
    </PageLayout>
);

export default ServicesPage;
